import { useTranslation } from 'react-i18next'

type DeclarationReadinessRequirement = {
  met: boolean
}

type DeclarationReadinessProgressProps = {
  requirements: DeclarationReadinessRequirement[]
  generateReady: boolean
  labelKey: string
  readyHintKey: string
}

export function DeclarationReadinessProgress({
  requirements,
  generateReady,
  labelKey,
  readyHintKey,
}: DeclarationReadinessProgressProps) {
  const { t } = useTranslation('common')
  const requirementCount = requirements.length
  const metCount = requirements.filter((requirement) => requirement.met).length
  const progressPercent =
    requirementCount === 0
      ? 0
      : Math.round((metCount / requirementCount) * 100)

  return (
    <div className='space-y-2'>
      <div className='flex items-center justify-between gap-2 text-xs text-muted-foreground'>
        <span>
          {t(labelKey, {
            met: metCount,
            total: requirementCount,
          })}
        </span>
      </div>
      <div
        className='h-1.5 w-full overflow-hidden rounded-full bg-muted'
        role='progressbar'
        aria-valuemin={0}
        aria-valuemax={requirementCount}
        aria-valuenow={metCount}
        aria-label={t(labelKey, {
          met: metCount,
          total: requirementCount,
        })}
      >
        <div
          className='h-full rounded-full bg-primary transition-[width]'
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      {generateReady ? (
        <p className='text-xs text-muted-foreground'>{t(readyHintKey)}</p>
      ) : null}
    </div>
  )
}
